export default {
  name: 'i-copyright'
};